import Vue from "vue";
// @ts-ignore
import Keycloak from "keycloak-js";
import SecurityService from "@/service/security.service";

const {KEYCLOAK_URL, KEYCLOAK_REALM, KEYCLOAK_CLIENT_ID} = window['_env_'] || {};

const keycloak = new Keycloak({
    realm: KEYCLOAK_REALM,
    url: KEYCLOAK_URL,
    clientId: KEYCLOAK_CLIENT_ID
});

Vue.prototype.$keycloak = Vue.observable({
    keycloak: keycloak,
    authenticated: false,
    ready: false,
    token: null,
    refreshToken: null,
    tokenParsed: null,
    userName: null,
    createLoginUrl: null,
    createLogoutUrl: keycloak.createLogoutUrl.bind(keycloak),
    login: keycloak.login.bind(keycloak),
    logout: keycloak.logout.bind(keycloak),
    updateToken: keycloak.updateToken.bind(keycloak),
    clearToken: keycloak.clearToken.bind(keycloak)
});

export const keycloakInitOptions = {
    onLoad: 'check-sso' as const,
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    checkLoginIframe: false,
    timeSkew: 0
};

const refreshTokenIfNeeded = async () => {
    if (!keycloak.authenticated) return;

    try {
        const refreshed = await keycloak.updateToken(120);
        if (refreshed) {
            Vue.prototype.$keycloak.token = keycloak.token;
            Vue.prototype.$keycloak.refreshToken = keycloak.refreshToken;
            Vue.prototype.$keycloak.tokenParsed = keycloak.tokenParsed;
            SecurityService.setKeycloakAuthorization();
        }
    } catch (error) {
        keycloak.logout();
    }
};

let refreshInterval: number | null = null;

keycloak.init(keycloakInitOptions)
    .then((authenticated: boolean) => {

        Object.assign(Vue.prototype.$keycloak, {
            keycloak: keycloak,
            authenticated: authenticated,
            ready: true,
            token: keycloak.token,
            refreshToken: keycloak.refreshToken,
            tokenParsed: keycloak.tokenParsed,
            userName: (keycloak.tokenParsed as any)?.preferred_username,
            createLoginUrl: keycloak.createLoginUrl.bind(keycloak),
            createLogoutUrl: keycloak.createLogoutUrl.bind(keycloak),
            login: keycloak.login.bind(keycloak),
            logout: keycloak.logout.bind(keycloak),
            updateToken: keycloak.updateToken.bind(keycloak),
            clearToken: keycloak.clearToken.bind(keycloak)
        });

        keycloak.onTokenExpired = () => {
            keycloak.updateToken(120).then((refreshed: boolean) => {
                if (refreshed) {
                    Vue.prototype.$keycloak.token = keycloak.token;
                    Vue.prototype.$keycloak.refreshToken = keycloak.refreshToken;
                    Vue.prototype.$keycloak.tokenParsed = keycloak.tokenParsed;
                    SecurityService.setKeycloakAuthorization();
                } else {
                    keycloak.logout();
                }
            }).catch((error) => {
                keycloak.logout();
            });
        };

        if (authenticated) {
            SecurityService.setKeycloakAuthorization();

            if (refreshInterval) {
                clearInterval(refreshInterval);
            }

            refreshInterval = setInterval(refreshTokenIfNeeded, 100000);

            refreshTokenIfNeeded();
        }
    })
    .catch((error: any) => {
        Object.assign(Vue.prototype.$keycloak, {
            keycloak: keycloak,
            authenticated: false,
            ready: true,
            token: null,
            refreshToken: null,
            tokenParsed: null,
            userName: null,
            createLoginUrl: keycloak.createLoginUrl.bind(keycloak),
            createLogoutUrl: keycloak.createLogoutUrl.bind(keycloak),
            login: keycloak.login.bind(keycloak),
            logout: keycloak.logout.bind(keycloak),
            updateToken: keycloak.updateToken.bind(keycloak),
            clearToken: keycloak.clearToken.bind(keycloak)
        });
    });

window.addEventListener('beforeunload', () => {
    if (refreshInterval) {
        clearInterval(refreshInterval);
    }
});

export { keycloak };
